import { Step } from 'utils/enumerations';

export const diggingPermitCase = {
  gid: 'test',
  caseType: 1,
  currentStep: Step.Basic,
  caseNumber: `testdiggingpermit1`,
  applicant: {
    applicantName: 'Applicant A',
    organisationName: 'Org A',
    phoneNumber: '+4609876534',
    mobilePhoneNumber: '09080780909',
    email: 'name@esri-sgroup.com',
    socialSecurityNumber: '',
    organisationNumber: '2220000315'
  },
  billingInformation: {
    billingAddress: 'Address 1',
    billingPostalCode: '11111',
    billingPostalCity: 'PostalCity 1',
    alternativeBillingAddress: 'Address 2',
    alternativeBillingPostalCode: '22222',
    alternativeBillingPostalCity: 'PostalCity 2',
    invoiceMarking: 'Mark1'
  },
  entrepreneur: {
    entrepreneurName: 'Entrepreneur 1',
    entrepreneurAddress: 'Address 3',
    entrepreneurPostalCode: '33333',
    entrepreneurPostalCity: 'PostalCity 3',
    entrepreneurOrganisationNumber: '',
    supervisorName: 'Foreman Supervisor',
    supervisorPhoneNumber: '012345678',
    supervisorMobilePhoneNumber: '123456789',
    supervisorEmail: 'b@b.se'
  },
  purpose: {
    workTypes: []
  },
  executedIns: [],
  workMethodAndDepth: {
    workMethod: []
  },
  points: [],
  polylines: [],
  polygons: [],
  attachments: [],
  childCases: []
};

export const taPlanCase = {
  gid: 'test2',
  caseType: 3,
  currentStep: Step.Basic,
  caseNumber: `testtaplan1`,
  applicant: {
    applicantName: 'Applicant A',
    organisationName: 'Org A',
    phoneNumber: '+4609876534',
    mobilePhoneNumber: '09080780909',
    email: 'name@esri-sgroup.com',
    socialSecurityNumber: '',
    organisationNumber: '2220000315'
  },
  billingInformation: {
    billingAddress: 'Address 1',
    billingPostalCode: '11111',
    billingPostalCity: 'PostalCity 1',
    alternativeBillingAddress: 'Address 2',
    alternativeBillingPostalCode: '22222',
    alternativeBillingPostalCity: 'PostalCity 2',
    invoiceMarking: 'Mark1'
  },
  caseInfo: {
    caseName: 'Entrepreneur 1',
    location: 'Address 3'
  },
  roadSignRegulations: [],
  managers: {
    markingManager: 'MarkingManager 1',
    markingManagerMobilePhoneNumber: '09080780909',
    inspectionManager: 'InspectorManager 1',
    inspectionManagerMobilePhoneNumber: '09080755509'
  },
  points: [],
  polylines: [],
  polygons: [],
  attachments: [],
  childCases: []
};
